import { Link } from "react-router-dom";
import { Instagram, Facebook, Music2, MapPin, Phone, Mail } from "lucide-react";
import { SITE, HOURS, formatHour } from "@/data/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-espresso text-cream">
    <div className="pointer-events-none select-none px-4 pt-14 text-center" aria-hidden="true">
      <span className="outline-word block whitespace-nowrap font-display text-[13vw] font-black leading-[0.85] tracking-tight">
        BABYLON
      </span>
    </div>

    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-3">
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-amber">Visit</p>
        <p className="mt-4 flex items-start gap-3 text-sm leading-relaxed text-cream/80">
          <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-rust" />
          {SITE.address}
        </p>
        <a
          href={SITE.phoneHref}
          data-testid="footer-phone-link"
          className="mt-3 flex items-center gap-3 text-sm text-cream/80 transition-colors duration-300 hover:text-amber"
        >
          <Phone className="h-4 w-4 shrink-0 text-rust" />
          {SITE.phone} · {SITE.contact}
        </a>
        <a
          href={SITE.emailHref}
          data-testid="footer-email-link"
          className="mt-3 flex items-center gap-3 text-sm text-cream/80 transition-colors duration-300 hover:text-amber"
        >
          <Mail className="h-4 w-4 shrink-0 text-rust" />
          {SITE.email}
        </a>
      </div>

      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-amber">Hours</p>
        <ul className="mt-4 space-y-1.5 text-sm text-cream/80">
          {HOURS.map((h) => (
            <li key={h.day} className="flex items-baseline justify-between gap-4">
              <span className="text-xs">{h.day}</span>
              <span className="font-mono text-[11px] text-cream/60">
                {formatHour(h.open)} – {formatHour(h.close)}
              </span>
            </li>
          ))}
        </ul>
        <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.18em] text-cream/40">
          Deli counter closes 1 hr earlier
        </p>
      </div>

      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-amber">Follow</p>
        <div className="mt-4 flex flex-col gap-3">
          <a
            href={SITE.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="group inline-flex items-center gap-3 text-sm text-cream/80 transition-colors duration-300 hover:text-amber"
          >
            <span className="grid h-9 w-9 place-items-center rounded-full border border-cream/20 transition-colors duration-300 group-hover:border-amber">
              <Instagram className="h-4 w-4" />
            </span>
            Instagram · {SITE.instagramHandle}
          </a>
          <a
            href={SITE.facebook}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-facebook-link"
            className="group inline-flex items-center gap-3 text-sm text-cream/80 transition-colors duration-300 hover:text-amber"
          >
            <span className="grid h-9 w-9 place-items-center rounded-full border border-cream/20 transition-colors duration-300 group-hover:border-amber">
              <Facebook className="h-4 w-4" />
            </span>
            Facebook · {SITE.facebookHandle}
          </a>
          <a
            href={SITE.tiktok}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-tiktok-link"
            className="group inline-flex items-center gap-3 text-sm text-cream/80 transition-colors duration-300 hover:text-amber"
          >
            <span className="grid h-9 w-9 place-items-center rounded-full border border-cream/20 transition-colors duration-300 group-hover:border-amber">
              <Music2 className="h-4 w-4" />
            </span>
            TikTok · {SITE.tiktokHandle}
          </a>
        </div>
      </div>
    </div>

    <div className="border-t border-cream/10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-5 py-6 font-mono text-[11px] uppercase tracking-[0.2em] text-cream/50 sm:flex-row sm:px-8">
        <span>© 2026 Babylon Deli</span>
        <div className="flex items-center gap-6">
          <Link to="/menu" data-testid="footer-menu-link" className="transition-colors duration-300 hover:text-amber">
            Menu
          </Link>
          <Link to="/catering" data-testid="footer-catering-link" className="transition-colors duration-300 hover:text-amber">
            Catering
          </Link>
          <span>Fresh &amp; Authentic</span>
        </div>
      </div>
    </div>
  </footer>
);
